import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
    Box,
    Breadcrumbs,
    Button,
    Container,
    // Divider, // Using ListItem divider prop primarily
    IconButton,
    Link,
    Typography,
    Paper,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Chip,
    useTheme, // Added Chip for the category tag
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'; // Example icons
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; // Example icons
import SettingsIcon from '@mui/icons-material/Settings'; // Icon for settings section

import queryGraphql from "../../helpers/ApiInterface";
import MiniBot from "../MiniBot";


import MainDrawer, { openDrawerWidth, collapsedDrawerWidth } from "../MainDrawer"; // Adjust path if needed


const GCPCostAgentContent: React.FC = () => {
    const navigate = useNavigate();
    const [costAgentData, setCostAgentData] = useState<any | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getIntegrationsQuery = `
        query Query {
          getIntegrations {
            costAgent {
              datasetId
              enabled
              projectId
              tableId
              updatedAt
            }
          }
        }
    `;

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await queryGraphql(getIntegrationsQuery);
                if (response?.getIntegrations?.costAgent) {
                    setCostAgentData(response.getIntegrations.costAgent);
                } else {
                    console.error("GCP Cost Agent data not found or structure mismatch:", response);
                    setCostAgentData(null);
                }
            } catch (error) {
                console.error("Error fetching GCP Cost Agent integration data:", error);
                setCostAgentData(null);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const formatDate = (timestamp: string | number | null | undefined): string => {
        if (timestamp === null || timestamp === undefined) return "N/A";
        let date: Date | null = null;
        try {
            if (typeof timestamp === 'number') {
                // Assume milliseconds if number. Add logic here if it might be seconds (e.g., multiply by 1000).
                date = new Date(timestamp);
            } else if (typeof timestamp === 'string') {
                // Try parsing as a number first (common for millisecond timestamps as strings)
                const nTs = Number(timestamp);
                // Check if it looks like a valid numeric timestamp string
                if (!isNaN(nTs) && timestamp.length >= 10 && String(nTs) === timestamp) {
                     date = new Date(nTs); // Use the parsed number
                } else {
                    // Otherwise, try parsing the string directly (e.g., ISO 8601 format)
                    date = new Date(timestamp);
                }
            }

            // Final validation check
            if (date && !isNaN(date.getTime())) {
                // Format as DD/MM/YYYY using 'en-GB' locale
                return date.toLocaleDateString('en-GB', {
                    day: '2-digit',   // Ensures DD
                    month: '2-digit',  // Ensures MM
                    year: 'numeric'   // Ensures YYYY
                });
            } else {
                console.error(`Invalid or unparseable date format received: ${timestamp}`);
                return "Invalid Date"; // Or return "N/A"
            }
        } catch (e) {
            console.error(`Error parsing date (${timestamp}):`, e);
            return "Error"; // Or return "N/A"
        }
    };
    // Updated date formatter to be more concise for header display
    //  const formatDate = (isoString: string | null): string => {
    //     if (!isoString) return "N/A";
    //     try {
    //         // Example: "08/04/2025" (adjust format as needed)
    //         return new Date(isoString).toLocaleDateString();
    //     } catch (e) {
    //         console.error("Error formatting date:", e);
    //         return "Invalid Date";
    //     }
    // };
    // // Keep detailed formatter if needed elsewhere, or combine
    // const formatDateTime = (isoString: string | null): string => {
    //     if (!isoString) return "N/A";
    //     try {
    //         return new Date(isoString).toLocaleString(); // Includes time
    //     } catch (e) {
    //         console.error("Error formatting date/time:", e);
    //         return "Invalid Date";
    //     }
    // };


    return (
        <Container
            disableGutters
            maxWidth={false}
            sx={{ padding: "24px", bgcolor: "#fafafa", minHeight: "100vh" }}
        >
            {/* --- Header (Stays Left-Aligned) --- */}
            <Box sx={{ mb: 2 }}> {/* Reduced bottom margin */}
                <MiniBot/>
                 <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={(e) => { e.preventDefault(); navigate("/integrations"); }}
                        sx={{ cursor: 'pointer' }}
                    >
                        Integrations
                    </Link>
                    <Typography color="text.primary" sx={{ fontSize: "0.875rem", fontFamily: 'Gilroy-Regular' }}>
                        GCP Cost Agent
                    </Typography>
                </Breadcrumbs>
                <Box display="flex" alignItems="center" justifyContent="space-between" mt={1.5}> {/* Reduced top margin */}
                    <Box display="flex" flexDirection="row">
                    <IconButton
                        edge="start"
                        aria-label="back"
                        color="inherit"
                        onClick={() => navigate("/integrations")}
                        sx={{ mr: 1, p: 0.5 }}
                    >
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>
                    <Typography fontFamily="Gilroy-Bold" fontSize="20px"> {/* Slightly larger title */}
                        GCP Cost Agent
                    </Typography>
                    </Box>
                                                <IconButton
                                                          aria-label="Help" 
                                                          onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
                                                          sx={{
                                                            padding: 0, 
                                                            border: 'none',  
                                                            ml:2,
                                                            '&:hover': {
                                                              
                                                              backgroundColor: 'action.hover', 
                                                            },
                                                            
                                                          }}
                                                        >
                                                          <Box
                                                            component="img"
                                                            src="/assets/Help.svg" 
                                                            alt="" 
                                                            sx={{
                                                              width: 40,  
                                                              height: 40,
                                                              display: 'block', 
                                                            }}
                                                          />
                                                        </IconButton>
                </Box>
                 {/* Optional: Subtitle similar to Checkov */}
                 {/* <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', mt: 0.5, pl: '44px' }}> {/* Indent to align roughly under title */}
                    {/* Review the configuration details for GCP Cost Agent. */}
                 {/* </Typography> */}
            </Box>

            {/* --- Content Wrapper (Centered Block) --- */}
            <Box sx={{ mx: 'auto', mt: 3 }}> {/* Wider maxWidth, less top margin */}
                {isLoading ? (
                    // --- Loading State ---
                     <Paper elevation={0} sx={{ p: 3, textAlign: 'center', border: "1px solid #E0E0E0", borderRadius: "12px" }}>
                        <CircularProgress />
                        <Typography sx={{ mt: 2, fontFamily: 'Gilroy-Regular' }}>Loading Integration Details...</Typography>
                     </Paper>
                ) : costAgentData && costAgentData.enabled ? (
                    // --- Data Loaded and Enabled ---
                    <Paper elevation={1} sx={{ borderRadius: "12px", overflow: 'hidden', border: "1px solid #E0E0E0" }}>
                        {/* === Enhanced Card Header === */}
                        <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #eee' }}>
                            {/* Left side: Icon, Name, Tag */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '40px', height: '40px' }} />
                                <Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography fontFamily="Gilroy-Bold" fontSize="18px">
                                            GCP Cost Agent
                                        </Typography>
                                        
                                        <Chip /* Keep chip styling as is */
                                           label="COST MANAGEMENT" size="small"
                                           sx={{ ml: 1.5, height: '20px', lineHeight: '1', borderRadius: '4px', bgcolor: '#f5f5f5', color: '#616161', fontFamily: 'Gilroy-Regular', fontWeight: 400, fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '1.25px', '& .MuiChip-label': { px: '10px', py: '4px' } }}/>
                                        {/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
                                            Lorem ipsum dolor sum it. Lorem ipsum dolor sum it.
                                        </Typography> */}
                                    </Box>
                                    {/* Optional Description if available/needed
                                    <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', mt: 0.5 }}>
                                        Provides cost analysis based on GCP billing data.
                                    </Typography>
                                    */}
                                </Box>
                            </Box>
                            {/* Right side: Install/Update Date */}
                            <Box sx={{ textAlign: 'right', pt: 0.5 }}> {/* Add padding top to align better */}
                                <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular' }}>
                                    Last Updated On:
                                </Typography>
                                <Typography variant="body2" sx={{ fontFamily: 'Gilroy-Medium' }}>
                                    {formatDate(costAgentData.updatedAt)} {/* Use concise date format */}
                                </Typography>
                            </Box>
                        </Box>

                        {/* === Card Body Section: Configuration === */}
                        <Box sx={{ bgcolor: '#f9f9f9' }}> {/* Section Header Background */}
                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5, pl: 2.5 }}>
                                 <SettingsIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="text.secondary">
                                    Configuration Settings
                                 </Typography>
                             </Box>
                        </Box>

                        {/* Settings List */}
                        <List disablePadding sx={{ bgcolor: 'background.paper' }}> {/* White background for list area */}
                            {/* Project ID */}
                            <ListItem divider sx={{ py: 1.5, px: 2.5 }}>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2" color="text.primary" sx={{ fontFamily: 'Gilroy-Medium' }}>
                                            Project ID
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
                                            {costAgentData.projectId || "N/A"}
                                        </Typography>
                                    }
                                    primaryTypographyProps={{ variant: 'body2' }} // Ensure consistent sizing
                                    secondaryTypographyProps={{ variant: 'body2' }} // Ensure consistent sizing
                                 />
                            </ListItem>

                            {/* Dataset ID */}
                            <ListItem divider sx={{ py: 1.5, px: 2.5 }}>
                                 <ListItemText
                                    primary={
                                        <Typography variant="body2" color="text.primary" sx={{ fontFamily: 'Gilroy-Medium' }}>
                                            Dataset ID
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
                                            {costAgentData.datasetId || "N/A"}
                                        </Typography>
                                    }
                                    primaryTypographyProps={{ variant: 'body2' }}
                                    secondaryTypographyProps={{ variant: 'body2' }}
                                 />
                            </ListItem>

                            {/* Table ID */}
                            <ListItem divider sx={{ py: 1.5, px: 2.5 }}>
                                 <ListItemText
                                    primary={
                                        <Typography variant="body2" color="text.primary" sx={{ fontFamily: 'Gilroy-Medium' }}>
                                            Table ID
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
                                             {costAgentData.tableId || "N/A"}
                                        </Typography>
                                    }
                                    primaryTypographyProps={{ variant: 'body2' }}
                                    secondaryTypographyProps={{ variant: 'body2' }}
                                 />
                            </ListItem>

                            {/* Status */}
                            <ListItem sx={{ py: 1.5, px: 2.5 }}>
                                 <ListItemText
                                    primary={
                                        <Typography variant="body2" color="text.primary" sx={{ fontFamily: 'Gilroy-Medium' }}>
                                            Status
                                        </Typography>
                                    }
                                    secondary={
                                         <Typography
                                             variant="body2" // Match size
                                             sx={{
                                                 fontFamily: 'Gilroy-SemiBold',
                                                 color: costAgentData.enabled ? 'success.main' : 'error.main'
                                             }}
                                         >
                                            {costAgentData.enabled ? "Enabled" : "Disabled"}
                                        </Typography>
                                    }
                                    primaryTypographyProps={{ variant: 'body2' }}
                                    secondaryTypographyProps={{ variant: 'body2' }}
                                 />
                            </ListItem>
                        </List>
                        {/* <Box sx={{ p: 2.5, textAlign: "right", borderTop: '1px solid #eee' }}> 
                            <Button
                                onClick={() => navigate('/cost-agent/dashboard')} // Use the navigate function defined above
                                sx={{
                                    backgroundColor: "black", color: "white",
                                    fontFamily: "Gilroy-Bold", fontSize: "14px", borderRadius: "8px",
                                    textTransform: "none", px: 4, transition: 'background-color 0.3s ease',
                                    '&:hover': { backgroundColor: "dimgray" },
                                    '&:disabled': { backgroundColor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.26)', cursor: 'not-allowed' },
                                }}
                                variant="contained" size="small"
                            >
                                Go to Cost Insights
                            </Button>
                        </Box> */}
                    </Paper>
                    
                    
                 ) : costAgentData && !costAgentData.enabled ? (
                     // --- Data Loaded but Not Enabled/Configured (Keep this layout) ---
                     <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center' }}>
                        <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '40px', height: '40px', marginBottom: '16px' }} />
                         <Typography variant="h6" sx={{ fontFamily: 'Gilroy-SemiBold', mb: 1 }}>
                             GCP Cost Agent Not Configured
                         </Typography>
                         <Typography color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', mb: 2 }}>
                             This integration is currently disabled or hasn't been set up yet.
                         </Typography>
                         <Button
                             variant="contained"
                             onClick={() => navigate("/integrations/explorePlugins")}
                             sx={{
                                 backgroundColor: "black", color: "white",
                                 fontFamily: "Gilroy-Bold", fontSize: "14px", borderRadius: "8px",
                                 textTransform: "none", px: 4,
                                 '&:hover': { backgroundColor: "dimgray" },
                             }}
                         >
                             Configure Now
                         </Button>
                     </Paper>
                ) : (
                    // --- Error State (Keep this layout) ---
                     <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center', borderColor: 'error.main' }}>
                        <Typography color="error" sx={{ fontFamily: 'Gilroy-SemiBold' }}>
                             Failed to load GCP Cost Agent integration details. Please try again later.
                         </Typography>
                     </Paper>
                )}
            </Box> {/* End of Centered Content Wrapper */}

        </Container>
    );
}

const GCPCostAgent: React.FC = () => {
    const theme = useTheme();

    const getInitialDrawerState = () => {
        if (typeof window !== 'undefined') {
            const storedState = localStorage.getItem('isFaradayDrawerOpen');
            return storedState !== null ? JSON.parse(storedState) : true;
        }
        return true;
    };
    const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);

    const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
        setIsDrawerActuallyOpen(isOpenFromDrawer);
    };

    // Using your remembered calculation for marginLeft
    const currentMarginLeft = isDrawerActuallyOpen ? openDrawerWidth - 248 : collapsedDrawerWidth - 70;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"integrations"} // Or a more specific index like "integrations-kyverno" if applicable
                onStateChange={handleDrawerStateChange}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    // bgcolor: '#fafafa', // bgcolor commented out as per your previous change
                    p: 0,
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    // Using your remembered unit and calculation for marginLeft
                    marginLeft: `${currentMarginLeft}vh`,
                }}
            >
                <GCPCostAgentContent />
            </Box>
        </Box>
    );
};



export default GCPCostAgent;
// import { useNavigate } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     Breadcrumbs,
//     Button,
//     Container,
//     Divider,
//     // Grid, // No longer using Grid for the detail list
//     IconButton,
//     Link,
//     Typography,
//     Paper,
//     CircularProgress,
//     List,
//     ListItem,
//     ListItemText
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import queryGraphql from "../../helpers/ApiInterface";

// const GCPCostAgent: React.FC = () => {
//     const navigate = useNavigate();
//     const [costAgentData, setCostAgentData] = useState<any | null>(null);
//     const [isLoading, setIsLoading] = useState<boolean>(true);

//     const getIntegrationsQuery = `
//         query Query {
//           getIntegrations {
//             costAgent {
//               datasetId
//               enabled
//               projectId
//               tableId
//               updatedAt
//             }
//           }
//         }
//     `;

//     useEffect(() => {
//         const fetchData = async () => {
//             setIsLoading(true);
//             try {
//                 const response = await queryGraphql(getIntegrationsQuery);
//                 if (response?.getIntegrations?.costAgent) {
//                     setCostAgentData(response.getIntegrations.costAgent);
//                 } else {
//                     console.error("GCP Cost Agent data not found or structure mismatch:", response);
//                     setCostAgentData(null);
//                 }
//             } catch (error) {
//                 console.error("Error fetching GCP Cost Agent integration data:", error);
//                 setCostAgentData(null);
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchData();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const formatDateTime = (isoString: string | null): string => {
//         if (!isoString) return "N/A";
//         try {
//             return new Date(isoString).toLocaleString();
//         } catch (e) {
//             console.error("Error formatting date:", e);
//             return "Invalid Date";
//         }
//     };

//     return (
//         // Main container - keeps background and overall padding
//         <Container
//             disableGutters
//             maxWidth={false} // Takes full width
//             sx={{ padding: "24px", bgcolor: "#fafafa", minHeight: "100vh" }}
//         >
//             {/* --- Header (Stays Left-Aligned) --- */}
//             {/* This Box respects the Container's padding but isn't centered */}
//             <Box sx={{ mb: 4 }}>
//                  <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                     <Link
//                         underline="hover"
//                         color="inherit"
//                         onClick={(e) => { e.preventDefault(); navigate("/integrations/integrations"); }}
//                         sx={{ cursor: 'pointer' }}
//                     >
//                         Integrations
//                     </Link>
//                     <Typography color="text.primary" sx={{ fontSize: "0.875rem" }}>
//                         GCP Cost Agent
//                     </Typography>
//                 </Breadcrumbs>
//                 <Box display="flex" alignItems="center" mt={2}>
//                     <IconButton
//                         edge="start"
//                         aria-label="back"
//                         color="inherit"
//                         onClick={() => navigate("/integrations/integrations")}
//                         sx={{ mr: 1, p: 0.5 }}
//                     >
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px">
//                         GCP Cost Agent Integration Details
//                     </Typography>
//                 </Box>
//             </Box>

//             {/* --- Content Wrapper (Centered Block) --- */}
//             {/* This Box constrains the width and centers the content block below the header */}
//             <Box sx={{ maxWidth: 'md', mx: 'auto', mt: 4 }}>
//                 {isLoading ? (
//                     // --- Loading State ---
//                     // Paper gives it a background and padding consistent with other states
//                      <Paper elevation={0} sx={{ p: 3, textAlign: 'center', border: "1px solid #E0E0E0", borderRadius: "12px" }}>
//                         <CircularProgress />
//                         <Typography sx={{ mt: 2, fontFamily: 'Gilroy-Regular' }}>Loading Integration Details...</Typography>
//                      </Paper>
//                 ) : costAgentData && costAgentData.enabled ? (
//                     // --- Data Loaded and Enabled ---
//                     <Paper elevation={1} sx={{ borderRadius: "12px", overflow: 'hidden', border: "1px solid #E0E0E0" }}>
//                         {/* Header within Paper */}
//                         <Box sx={{ p: 2.5, bgcolor: '#f9f9f9', borderBottom: '1px solid #E0E0E0' }}>
//                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                  <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '28px', height: '28px' }} />
//                                  <Typography fontFamily="Gilroy-SemiBold" fontSize="16px">
//                                     Configuration Details
//                                  </Typography>
//                              </Box>
//                         </Box>

//                         {/* Details List */}
//                         <List disablePadding>
//                             {/* Project ID */}
//                             <ListItem divider sx={{ py: 1.5 }}> {/* Add vertical padding */}
//                                 <ListItemText
//                                     primary={
//                                         <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                             Project ID
//                                         </Typography>
//                                     }
//                                     secondary={
//                                         <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                             {costAgentData.projectId || "N/A"}
//                                         </Typography>
//                                     }
//                                  />
//                             </ListItem>

//                             {/* Dataset ID */}
//                             <ListItem divider sx={{ py: 1.5 }}> {/* Add vertical padding */}
//                                  <ListItemText
//                                     primary={
//                                         <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                             Dataset ID
//                                         </Typography>
//                                     }
//                                     secondary={
//                                         <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                             {costAgentData.datasetId || "N/A"}
//                                         </Typography>
//                                     }
//                                  />
//                             </ListItem>

//                             {/* Table ID */}
//                             <ListItem divider sx={{ py: 1.5 }}> {/* Add vertical padding */}
//                                  <ListItemText
//                                     primary={
//                                         <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                             Table ID
//                                         </Typography>
//                                     }
//                                     secondary={
//                                         <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                              {costAgentData.tableId || "N/A"}
//                                         </Typography>
//                                     }
//                                  />
//                             </ListItem>

//                             {/* Last Updated */}
//                             <ListItem divider sx={{ py: 1.5 }}> {/* Add vertical padding */}
//                                  <ListItemText
//                                     primary={
//                                          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                             Last Updated
//                                         </Typography>
//                                     }
//                                     secondary={
//                                          <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular' }}>
//                                             {formatDateTime(costAgentData.updatedAt)}
//                                         </Typography>
//                                     }
//                                  />
//                             </ListItem>

//                             {/* Enabled Status */}
//                             <ListItem sx={{ py: 1.5 }}> {/* Add vertical padding */}
//                                  <ListItemText
//                                     primary={
//                                         <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                             Status
//                                         </Typography>
//                                     }
//                                     secondary={
//                                          <Typography
//                                              variant="body1"
//                                              sx={{
//                                                  fontFamily: 'Gilroy-SemiBold',
//                                                  color: costAgentData.enabled ? 'success.main' : 'error.main'
//                                              }}
//                                          >
//                                             {costAgentData.enabled ? "Enabled" : "Disabled"}
//                                         </Typography>
//                                     }
//                                  />
//                             </ListItem>
//                         </List>
//                     </Paper>
//                  ) : costAgentData && !costAgentData.enabled ? (
//                      // --- Data Loaded but Not Enabled/Configured ---
//                      <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center' }}>
//                         <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '40px', height: '40px', marginBottom: '16px' }} />
//                          <Typography variant="h6" sx={{ fontFamily: 'Gilroy-SemiBold', mb: 1 }}>
//                              GCP Cost Agent Not Configured
//                          </Typography>
//                          <Typography color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', mb: 2 }}>
//                              This integration is currently disabled or hasn't been set up yet.
//                          </Typography>
//                          <Button
//                              variant="contained"
//                              onClick={() => navigate("/integrations/explore")}
//                              sx={{
//                                  backgroundColor: "black", color: "white",
//                                  fontFamily: "Gilroy-Bold", fontSize: "14px", borderRadius: "8px",
//                                  textTransform: "none", px: 4,
//                                  '&:hover': { backgroundColor: "dimgray" },
//                              }}
//                          >
//                              Configure Now
//                          </Button>
//                      </Paper>
//                 ) : (
//                     // --- Error State ---
//                      <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center', borderColor: 'error.main' }}>
//                         <Typography color="error" sx={{ fontFamily: 'Gilroy-SemiBold' }}>
//                              Failed to load GCP Cost Agent integration details. Please try again later.
//                          </Typography>
//                      </Paper>
//                 )}
//             </Box> {/* End of Centered Content Wrapper */}

//         </Container>
//     );
// }

// export default GCPCostAgent;
// import { useNavigate } from "react-router-dom";
// import React, { useState, useEffect } from "react"; // <-- Import useState and useEffect
// import {
//     Box,
//     Breadcrumbs,
//     Button, // <-- Added back for the "Configure Now" button
//     Container,
//     Divider,
//     Grid,
//     IconButton,
//     Link,
//     Typography,
//     Paper,
//     CircularProgress
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import queryGraphql from "../../helpers/ApiInterface";

// // Removed the CostAgentData interface definition

// const GCPCostAgent: React.FC = () => {
//     const navigate = useNavigate();
//     // State to store the fetched data - using 'any' type now
//     const [costAgentData, setCostAgentData] = useState<any | null>(null); // <-- Changed type to any | null
//     // State to handle loading status
//     const [isLoading, setIsLoading] = useState<boolean>(true);

//     // GraphQL Query
//     const getIntegrationsQuery = `
//         query Query {
//           getIntegrations {
//             costAgent {
//               datasetId
//               enabled
//               projectId
//               tableId
//               updatedAt
//             }
//           }
//         }
//     `;

//     // Fetch data on component mount
//     useEffect(() => {
//         const fetchData = async () => {
//             setIsLoading(true); // Start loading
//             try {
//                 const response = await queryGraphql(getIntegrationsQuery);
//                 // Directly access the expected path, assuming the structure
//                 if (response?.getIntegrations?.costAgent) {
//                     setCostAgentData(response.getIntegrations.costAgent);
//                 } else {
//                     console.error("GCP Cost Agent data not found or structure mismatch:", response);
//                     setCostAgentData(null);
//                 }
//             } catch (error) {
//                 console.error("Error fetching GCP Cost Agent integration data:", error);
//                 setCostAgentData(null); // Set data to null on error
//             } finally {
//                 setIsLoading(false); // End loading regardless of success/error
//             }
//         };

//         fetchData();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []); // Using empty dependency array assuming queryGraphql is stable or defined outside

//     // Helper function to format date/time
//     const formatDateTime = (isoString: string | null): string => {
//         if (!isoString) return "N/A";
//         try {
//             return new Date(isoString).toLocaleString();
//         } catch (e) {
//             console.error("Error formatting date:", e);
//             return "Invalid Date";
//         }
//     };

//     return (
//         <Container
//             disableGutters
//             maxWidth={false}
//             sx={{ padding: "24px", bgcolor: "#fafafa", minHeight: "100vh" }}
//         >
//             {/* --- Header (Breadcrumbs & Title) --- */}
//             <Box sx={{ mb: 4 }}>
//                 <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                     <Link
//                         underline="hover"
//                         color="inherit"
//                         onClick={(e) => { e.preventDefault(); navigate("/integrations/integrations"); }}
//                         sx={{ cursor: 'pointer' }}
//                     >
//                         Integrations
//                     </Link>
//                     <Typography color="text.primary" sx={{ fontSize: "0.875rem" }}>
//                         GCP Cost Agent
//                     </Typography>
//                 </Breadcrumbs>
//                 <Box display="flex" alignItems="center" mt={2}>
//                     <IconButton
//                         edge="start"
//                         aria-label="back"
//                         color="inherit"
//                         onClick={() => navigate("/integrations/integrations")}
//                         sx={{ mr: 1, p: 0.5 }}
//                     >
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px">
//                         GCP Cost Agent Integration Details
//                     </Typography>
//                 </Box>
//             </Box>

//             {/* --- Content Area --- */}
//             {isLoading ? (
//                 // --- Loading State ---
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 5 }}>
//                     <CircularProgress />
//                     <Typography sx={{ ml: 2 }}>Loading Integration Details...</Typography>
//                 </Box>
//             ) : costAgentData && costAgentData.enabled ? (
//                 // --- Data Loaded and Enabled ---
//                 <Paper elevation={1} sx={{ borderRadius: "12px", overflow: 'hidden', border: "1px solid #E0E0E0" }}>
//                      {/* Header within Paper */}
//                     <Box sx={{ p: 2.5, bgcolor: '#f9f9f9', borderBottom: '1px solid #E0E0E0' }}>
//                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                              <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '28px', height: '28px' }} />
//                              <Typography fontFamily="Gilroy-SemiBold" fontSize="16px">
//                                 Configuration Details
//                              </Typography>
//                          </Box>
//                     </Box>

//                     {/* Details Grid */}
//                     <Box sx={{ p: 3 }}>
//                         <Grid container spacing={2.5}>
//                              {/* Project ID */}
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                     Project ID
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                     {costAgentData.projectId || "N/A"}
//                                 </Typography>
//                             </Grid>

//                             {/* Dataset ID */}
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                     Dataset ID
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                     {costAgentData.datasetId || "N/A"}
//                                 </Typography>
//                             </Grid>

//                             {/* Table ID */}
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                     Table ID
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', wordBreak: 'break-all' }}>
//                                     {costAgentData.tableId || "N/A"}
//                                 </Typography>
//                             </Grid>

//                              {/* Separator */}
//                              <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>

//                              {/* Last Updated */}
//                              <Grid item xs={12} sm={4}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                     Last Updated
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular' }}>
//                                     {formatDateTime(costAgentData.updatedAt)}
//                                 </Typography>
//                             </Grid>

//                              {/* Enabled Status */}
//                               <Grid item xs={12} sm={4}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Gilroy-Medium' }}>
//                                     Status
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ fontFamily: 'Gilroy-Regular', color: costAgentData.enabled ? 'success.main' : 'error.main' }}>
//                                     {costAgentData.enabled ? "Enabled" : "Disabled"}
//                                 </Typography>
//                             </Grid>

//                         </Grid>
//                     </Box>
//                 </Paper>
//              ) : costAgentData && !costAgentData.enabled ? (
//                  // --- Data Loaded but Not Enabled/Configured ---
//                  <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center' }}>
//                      <img src="/assets/gcp.svg" alt="GCP Logo" style={{ width: '40px', height: '40px', marginBottom: '16px' }} />
//                      <Typography variant="h6" sx={{ fontFamily: 'Gilroy-SemiBold', mb: 1 }}>
//                          GCP Cost Agent Not Configured
//                      </Typography>
//                      <Typography color="text.secondary" sx={{ fontFamily: 'Gilroy-Regular', mb: 2 }}>
//                          This integration is currently disabled or hasn't been set up yet.
//                      </Typography>
//                      <Button
//                          variant="contained"
//                          onClick={() => navigate("/integrations/explore")} // Navigate to where user can install/configure
//                          sx={{
//                              backgroundColor: "black", color: "white",
//                              fontFamily: "Gilroy-Bold", fontSize: "14px", borderRadius: "8px",
//                              textTransform: "none", px: 4,
//                              '&:hover': { backgroundColor: "dimgray" },
//                          }}
//                      >
//                          Configure Now
//                      </Button>
//                  </Paper>
//             ) : (
//                 // --- Error State ---
//                  <Paper elevation={1} sx={{ borderRadius: "12px", p: 3, border: "1px solid #E0E0E0", textAlign: 'center', borderColor: 'error.main' }}>
//                     <Typography color="error" sx={{ fontFamily: 'Gilroy-SemiBold' }}>
//                          Failed to load GCP Cost Agent integration details. Please try again later.
//                      </Typography>
//                  </Paper>
//             )}
//         </Container>
//     );
// }

// export default GCPCostAgent;
// import { useNavigate } from "react-router-dom";
// import React, { useState } from "react";
// import {
// 	Autocomplete,
// 	Box,
// 	Breadcrumbs,
// 	Button,
// 	Container,
// 	Divider,
// 	Grid,
// 	IconButton,
// 	Link,
// 	TextField,
// 	Typography,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { ErrorMessage, Form, Formik, getIn } from "formik";
// import * as Yup from "yup";
// import CompulsoryFieldsLabel from "../../helpers/CompulsoryFields";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import MainDrawer from "../MainDrawer";

// const GCPCostAgent: React.FC =  () => {
//     const navigate = useNavigate();
//     return(
//         <Container
//                     disableGutters
//                     maxWidth={false}
//                     sx={{ padding: "24px", bgcolor: "#fafafa", minHeight: "100vh" }}
//                 >
//                     <Box sx={{ mb: 4 }}>
//                         <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                             <Link underline="hover" color="inherit" href="/integrations/integrations">
//                                 Integrations
//                             </Link>
//                             <Typography color="text.primary">
//                                 GCP Cost Agent
//                             </Typography>
//                         </Breadcrumbs>
//                         <Box display="flex" alignItems="center" mt={2}>
//                             <IconButton
//                                 edge="start"
//                                 aria-label="back"
//                                 color="inherit"
//                                 onClick={() => navigate("/integrations/integrations")}
//                             >
//                                 <ArrowBackIosNewIcon fontSize="small" />
//                             </IconButton>
//                             <Typography fontFamily="Gilroy-Bold" fontSize="18px">
//                                 GCP Cost Agent
//                             </Typography>
//                         </Box>
//                     </Box>

    
//         </Container>
//         )
    
//     }
    
// export default GCPCostAgent;
    